export default {
  CompanyList: () => import('@/views/company/listPage/CompanyList'),
}